import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Carry the destination so deep links (for example the Add Credits tab opened from
    // checkout) survive the login detour instead of dumping the user on /messages.
    const intended = `${location.pathname}${location.search}`;
    const target = intended && intended !== '/'
      ? `/login?returnUrl=${encodeURIComponent(intended)}`
      : '/login';
    return <Navigate to={target} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
